import React, { useState, useEffect } from 'react';
import apiClient from '../utils/apiClient';

const MessagesPage = () => {
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    setIsLoading(true);
    setError('');
    try {
      const response = await apiClient.get('/messages');
      setMessages(response.data || []);
    } catch (err) {
      setError('Failed to load messages');
      setMessages([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteMessage = async (id) => {
    if (!window.confirm('Are you sure you want to delete this message?')) {
      return;
    }

    try {
      await apiClient.delete(`/messages/${id}`);
      setMessages(messages.filter(m => m.id !== id));
      showSuccess('Message deleted successfully');
    } catch (err) {
      setError('Failed to delete message');
    }
  };

  const showSuccess = (message) => {
    setSuccessMessage(message);
    setTimeout(() => setSuccessMessage(''), 3000);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  return (
    <div>
      <div className="content-header">
        <h2>Messages ({messages.length})</h2>
      </div>

      {successMessage && <div className="alert alert-success">{successMessage}</div>}
      {error && <div className="alert alert-error">{error}</div>}

      {isLoading ? (
        <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
          Loading messages...
        </div>
      ) : messages.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
          No messages yet
        </div>
      ) : (
        <div className="messages-list">
          {messages.map(message => (
            <div key={message.id} className="message-card">
              <h4>{message.name}</h4>
              <div className="email">📧 {message.email}</div>
              <p>{message.message}</p>
              <div className="timestamp">📅 {formatDate(message.created_at)}</div>
              <button
                className="delete-btn"
                onClick={() => handleDeleteMessage(message.id)}
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MessagesPage;
